import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export var markBoundaryCursorPluginKey = new PluginKey('markBoundaryCursorPlugin');